
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProfileSetupForm from "@/components/auth/ProfileSetup";
import { useAuth } from "@/contexts/AuthContext";
import { Skeleton } from "@/components/ui/skeleton";

const ProfileSetup = () => {
  const navigate = useNavigate();
  const { user, profile, isLoading } = useAuth();
  const [isProfileCompleted, setIsProfileCompleted] = useState<boolean | null>(null);
  const [isChecking, setIsChecking] = useState(true);

  // Check if profile is already completed using AuthContext data
  useEffect(() => {
    if (!isLoading && user) {
      console.log("Checking profile completion status from AuthContext:", { profileCompleted: profile?.profile_completed });
      setIsChecking(true);
      
      if (profile?.profile_completed === true) {
        console.log("Profile already completed, redirecting to dashboard");
        setIsProfileCompleted(true);
        navigate("/dashboard", { replace: true });
      } else {
        setIsProfileCompleted(false);
      }
      
      setIsChecking(false);
    } else if (!isLoading && !user) {
      setIsChecking(false);
    }
  }, [user, profile?.profile_completed, isLoading, navigate]);

  // Redirect to login if not authenticated
  useEffect(() => {
    if (!user && !isLoading && !isChecking) {
      console.log("No user found, redirecting to login");
      navigate("/login", { replace: true });
    }
  }, [user, isLoading, isChecking, navigate]);

  if (isLoading || isChecking || isProfileCompleted === null) {
    return (
      <div className="min-h-screen bg-[#375062] flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-2xl">
          <div className="flex items-center justify-center gap-3 mb-2">
            <img src="/icon-mark.png" alt="Doyence" className="h-10 w-10" />
            <h1 className="text-3xl font-bold text-white">
              Doyence
            </h1>
          </div>
          <h2 className="text-center text-xl font-semibold text-white mb-8">
            Loading your profile
          </h2>
          <div className="space-y-4">
            <Skeleton className="h-12 w-full" />
            <Skeleton className="h-12 w-full" />
            <Skeleton className="h-12 w-full" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#375062] flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-2xl">
        <div className="flex items-center justify-center gap-3 mb-2">
          <img src="/icon-mark.png" alt="Doyence" className="h-10 w-10" />
          <h1 className="text-3xl font-bold text-white">
            Doyence
          </h1>
        </div>
        <h2 className="text-center text-xl font-semibold text-white">
          Complete your profile
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-2xl">
        <ProfileSetupForm />
      </div>
    </div>
  );
};

export default ProfileSetup;
